<template>
    <div class="container airport-stats">
        <div v-if="airportStats" class="airport-rating">
            <StarsRating :value="starsRatingNumber"></StarsRating>
            <strong
                >({{ airportStats.ratings.rating_by_customers.percentage }}%)
                {{ airportStats.ratings.surveys_count }} ratings</strong
            >
        </div>

        <div class="stats-table-container">
            <strong class="stats-table-title">Park Sleep Fly - Today's Key Info For {{ airport.content.code }}</strong>
            <table class="stats-table">
                <tbody>
                    <tr v-for="stat in statsList" :key="stat.label">
                        <td class="stats-label">
                            <strong>{{ stat.label }}</strong>
                        </td>
                        <td>{{ stat.value }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="airport-description">
            {{ blok.text }}
        </div>
    </div>
</template>

<script setup lang="ts">
import StarsRating from '@nuxt-monorepo/ui/components/common/StarsRating.vue';
import type { ISbStoryData } from '@storyblok/vue';
import type { IAirportStats, IAirportEntity, IAirportProducts, IHotelProduct } from '@nuxt-monorepo/ui/types';

interface IAirportStatsConfig {
    text: string;
    _uid: string;
    component: string;
    _editable: string;
}

const { blok, products, airport, airportStats } = defineProps<{
    blok: IAirportStatsConfig;
    products: IAirportProducts;
    airport: ISbStoryData<IAirportEntity>;
    airportStats?: IAirportStats | null | undefined;
}>();

const airportText = airport.content.type === 'port' ? 'Cruise Port' : 'Airport';
const statsList = computed(() => {
    return [
        {
            label: 'Overall Rating: ',
            value: airportStats ? `${airportStats?.ratings.rating_by_customers.percentage}% Rating` : '',
        },
        { label: 'Total Ratings:', value: airportStats ? `${airportStats?.ratings.surveys_count} Total Ratings` : '' },
        { label: 'Most Popular:', value: mostPopular.value?.name ?? '' },
        { label: `Closest to ${airportText}:`, value: closest.value?.name ?? '' },
        { label: 'Most Reviewed:', value: mostViewed.value?.name ?? '' },
    ];
});

const starsRatingNumber = computed(() => {
    return Math.floor(airportStats ? airportStats.ratings.rating_by_customers.outOfFiveFraction : 0);
});

const mostPopular = computed<IHotelProduct | undefined>(() => {
    return products.hotels?.[0];
});

const closest = computed<IHotelProduct | undefined>(() => {
    if (!products.hotels?.[0]) return;
    return products.hotels?.reduce((res: IHotelProduct, product: IHotelProduct) => {
        return product.overview.distance_to_airport > res.overview.distance_to_airport ? res : product;
    });
});

const mostViewed = computed<IHotelProduct | undefined>(() => {
    if (!products.hotels?.[0]) return;
    return products.hotels?.reduce((res: IHotelProduct, product: IHotelProduct) => {
        return product.overview.surveys_count < res.overview.surveys_count ? res : product;
    });
});
</script>

<style lang="postcss"></style>
